import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Image, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Progress } from "@heroui/react";
import axios from "axios";
import { FaFilePdf, FaFileWord, FaFileExcel } from 'react-icons/fa';
import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import DownloadZipButton from "../DownloadZipButton";
import LegacyDownloadButton from "../../LegacyDownloadButton";

export default (params) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [legacyData, setLegacyData] = useState(undefined);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isFileModalOpen, setIsFileModalOpen] = useState(false);
    const gridApi = params.api;

    //LightBox
    const [selectedImage, setSelectedImage] = useState(null);
    const [openLight, setOpenLight] = useState(false);
    //./LightBox

    useEffect(() => {
        if (!gridApi) return;

        const updateSelection = () => {
            const selected = gridApi.getSelectedRows();
            console.log("selected", selected);
            setSelectedRows(selected);
        };

        gridApi.addEventListener("selectionChanged", updateSelection);

        return () => {
            gridApi.removeEventListener("selectionChanged", updateSelection);
        };
    }, [gridApi]);

    const loadLegacyData = async () => {
        try {
            const selected = selectedRows[0]?.s_codigo;
            console.log("selected", selected);
            const response = await axios.get(`https://quickview.rskgroupco.com/app/legacy/files?s_id=${selected}`, {
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 10000
            });
            console.log("response", response.data);
            setLegacyData(response.data);
        } catch (error) {
            console.error('Error al cargar los datos:', error);
            setLegacyData(null);
        }
    };

    useEffect(() => {
        if (isOpen) {
            setLegacyData(undefined);
            loadLegacyData();
        }
    }, [isOpen]);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);

    const openFileModal = (file) => {
        setSelectedFile(file);
        setIsFileModalOpen(true);
    };

    const closeFileModal = () => {
        setIsFileModalOpen(false);
        setSelectedFile(null);
    };

    const handleImageClick = (imageUrl) => {
        setSelectedImage(imageUrl);
        setOpenLight(true);
    };

    //const filesEndpoint = 'https://rskfiles.darwinringele.com';
    const filesEndpoint = 'https://sistema-legado.s3.us-east-2.amazonaws.com';

    return (
        <>
            <div style={{ textAlign: "center" }}>
                <span>
                    <h2>
                        <i className="fa fa-calculator"></i> {params.title}
                    </h2>
                    <div style={{ fontSize: "large", padding: 10 }}>
                        <Button
                            size="sm"
                            onPress={onOpen}
                            isDisabled={selectedRows.length === 0}
                            className={`p-2 rounded ${selectedRows.length > 0 ? "bg-blue-500" : "bg-gray-300"} text-white`}
                        >
                            Ver detalle del registro
                        </Button>
                    </div>

                    <h3>Fila seleccionada:</h3>
                    <dl>
                        {selectedRows?.length > 0 ? (
                            <>
                                <li>{selectedRows[0]?.s_rsk || "Sin referencia"}</li>
                                <li>{selectedRows[0]?.s_container_a || "Sin referencia"}</li>
                            </>
                        ) : null}
                    </dl>
                </span>
            </div>

            <Modal
                isOpen={isOpen}
                onClose={onClose}
                size="5xl"
                className="max-h-[90vh] overflow-y-auto"
                isDismissable={false}
            >
                <ModalContent>
                    {() => (
                        <>
                            <ModalHeader className="flex flex-col gap-1">Ver detalles de adjuntos</ModalHeader>
                            <ModalBody>
                                {legacyData === undefined ? (
                                    <>
                                        <p>Cargando...</p>
                                        <Progress isIndeterminate aria-label="Cargando..." className="max-w-full" size="sm" />
                                    </>
                                ) : legacyData === null ? (
                                    <p>No hay datos disponibles.</p>
                                ) : (
                                    <>
                                        <div className="flex flex-col gap-3">
                                            <p>Mostrando documentos adjuntos asociados al registro</p>
                                        </div>

                                        {/* Documentos */}
                                        <h4 className="mt-4 font-bold">Documentos</h4>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                            {legacyData.documents.length > 0 ? (
                                                legacyData.documents.map((file, index) => {
                                                    const isImage = file.archivo_formato?.startsWith('image/');
                                                    const isPDF = file.archivo_formato === 'application/pdf';
                                                    const isWord = file.archivo_formato === 'application/msword' || file.archivo_formato === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
                                                    const isExcel = file.archivo_formato === 'application/vnd.ms-excel' || file.archivo_formato === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

                                                    return (
                                                        <div
                                                            key={file.id_archivo || index}
                                                            className="flex flex-col items-center text-center cursor-pointer"
                                                            onClick={() => openFileModal(file)}
                                                        >
                                                            {isImage ? (
                                                                <Image
                                                                    isZoomed
                                                                    isBlurred
                                                                    alt={file.archivo_nombre || `Attachment ${index + 1}`}
                                                                    src={`${filesEndpoint}${file.archivo_ruta}`}
                                                                    height={200}
                                                                    className="w-full object-cover"
                                                                />
                                                            ) : isPDF ? (
                                                                <FaFilePdf size={100} className="text-red-600" />
                                                            ) : isWord ? (
                                                                <FaFileWord size={100} className="text-blue-600" />
                                                            ) : isExcel ? (
                                                                <FaFileExcel size={100} className="text-green-600" />
                                                            ) : (
                                                                <p className="text-gray-500">Formato no soportado</p>
                                                            )}
                                                            <div className="mt-2">
                                                                <p><strong>{file.archivo_nombre || 'Sin nombre'}</strong></p>
                                                                <p className="text-sm text-gray-600">
                                                                    Peso: {(file.archivo_peso / 1024).toFixed(2)} KB
                                                                </p>
                                                            </div>
                                                        </div>
                                                    );
                                                })
                                            ) : (
                                                <p>No hay documentos disponibles.</p>
                                            )}
                                        </div>

                                        {/* Imágenes */}
                                        <h4 className="mt-4 font-bold">Imágenes</h4>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
                                            {legacyData.images.length > 0 ? (
                                                legacyData.images.map((image, index) => (

                                                <Image
                                                    key={index} // Clave única para React
                                                    isZoomed
                                                    isBlurred
                                                    alt={`Attachment Image ${index + 1}`}
                                                    src={`${filesEndpoint}${image.imagen_ruta_interna}`}
                                                    height={200}
                                                    className="cursor-pointer"
                                                    onClick={() => handleImageClick(`${filesEndpoint}${image.imagen_ruta_grande}`)}
                                                    //https://sistema-legado.s3.us-east-2.amazonaws.com/upload/archivos/risk/855/10/doc20040706185540.pdf
                                                />

                                                ))
                                            ) : (
                                                <p>No hay imágenes disponibles.</p>
                                            )}
                                        </div>

                                        {/*<div className="flex justify-end mt-4">*/}
                                        {/*    <LegacyDownloadButton files={legacyData} endpoint={filesEndpoint} fileName={"Legacy"} />*/}
                                        {/*</div>*/}

                                    </>
                                )}

                            {/* Lightbox para mostrar imagen en alta calidad */}
                            <Lightbox
                                open={openLight}
                                close={() => setOpenLight(false)}
                                slides={selectedImage ? [{ src: selectedImage }] : []}
                                carousel={{ finite: true }}
                                controller={{ close: true, prev: false, next: false }}
                                plugins={[Zoom]}
                            />
                            </ModalBody>
                            <ModalFooter>
                                <Button color="danger" variant="light" onPress={onClose}>
                                    Cerrar
                                </Button>
                            </ModalFooter>
                        </>
                    )}
                </ModalContent>
            </Modal>

            {/* Modal interno para previsualización */}
            {isFileModalOpen && (
                <Modal
                    isOpen={isFileModalOpen}
                    onClose={closeFileModal}
                    size="5xl"
                    className="max-h-[90vh] overflow-y-auto"
                >
                    <ModalContent>
                        {() => (
                            <>
                                <ModalHeader className="flex flex-col gap-1">
                                    {selectedFile?.archivo_nombre || selectedFile?.imagen_nombre || 'Sin nombre'}
                                </ModalHeader>
                                <ModalBody>
                                    {selectedFile && (
                                        <>
                                            <p>Peso: {((selectedFile.archivo_peso || selectedFile.imagen_peso || 0) / 1024).toFixed(2)} KB</p>
                                            <p>Formato: {selectedFile.archivo_formato || 'image'}</p>
                                            <div className="mt-4">
                                                {(selectedFile.archivo_formato?.startsWith('image/') || !selectedFile.archivo_formato) ? (
                                                    <img
                                                        src={`${filesEndpoint}${selectedFile.archivo_ruta || selectedFile.imagen_ruta}`}
                                                        alt={selectedFile.archivo_nombre || selectedFile.imagen_nombre}
                                                        className="max-w-full h-auto"
                                                    />
                                                ) : selectedFile.archivo_formato === 'application/pdf' ? (
                                                    <iframe
                                                        src={`${filesEndpoint}${selectedFile.archivo_ruta}`}
                                                        title={selectedFile.archivo_nombre}
                                                        className="w-full h-[60vh]"
                                                    />
                                                ) : (
                                                    (selectedFile.archivo_formato === 'application/msword' ||
                                                        selectedFile.archivo_formato === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                                                        selectedFile.archivo_formato === 'application/vnd.ms-excel' ||
                                                        selectedFile.archivo_formato === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                                                        selectedFile.archivo_formato === 'application/x-zip-compressed') ? (
                                                        <p>
                                                            Descarga el archivo:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.archivo_ruta}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Descargar
                                                            </a>
                                                        </p>
                                                    ) : (
                                                        <p>
                                                            Tipo de archivo no soportado en el modal. Descarga el archivo:{' '}
                                                            <a
                                                                href={`${filesEndpoint}${selectedFile.archivo_ruta}`}
                                                                className="text-blue-500"
                                                                download
                                                            >
                                                                Descargar
                                                            </a>
                                                        </p>
                                                    )
                                                )}
                                            </div>
                                        </>
                                    )}
                                </ModalBody>
                                <ModalFooter>
                                    <Button color="danger" variant="light" onPress={closeFileModal}>
                                        Cerrar
                                    </Button>
                                </ModalFooter>
                            </>
                        )}
                    </ModalContent>
                </Modal>
            )}
        </>
    );
};